import Loader from 'reusable/mobx-helpers/Loader'
import { makeAutoObservable } from 'mobx'
import { createStoreContext } from 'reusable/mobx-store-utils/storeUtils'
import ProposalsEditStore from '../ProposalsEditStore'
import { ProposalStep3Dto, ProposalStep3ServiceAnnualDto, ProposalStep3ServiceMonthlyDto, ProposalStep3ServiceOneTimeDto, ProposalStep3ServiceSessionDto, ProposalStep3ServiceUnitDto, ProposalStep3SingleDto } from '@gap/backend/app-services/proposal/models/ProposalStep3Dto'
import { ServiceRateTypeEnum } from '@gap/backend/app-services/services/models/ServiceRateTypesDto'
import { ProposalDto } from '@gap/backend/app-services/proposal/models/ProposalDto'

interface ProposalsEditPaymentStoreProps {
   proposalsEditStore: ProposalsEditStore
}

export default class ProposalsEditPaymentStore {
   loader = new Loader(false)
   proposal: ProposalDto
   sp

   constructor(sp: ProposalsEditPaymentStoreProps) {
      makeAutoObservable(this)
      this.sp = sp
      this.proposal = JSON.parse(JSON.stringify(this.sp.proposalsEditStore.proposal))

      this.markStepStatus(true)
   }

   get markStepStatus() {
      return this.sp.proposalsEditStore.stepperFullscreenStore.markStepStatus
   }

   get step(): ProposalStep3Dto {
      if (!this.proposal.step3) {
         this.proposal.step3 = []
      }
      return this.proposal.step3
   }

   set step(step: ProposalStep3Dto) {
      this.proposal.step3 = step
      this.sp.proposalsEditStore.autoSave.updateProposal(this.proposal)
   }

   set stepRateType(stepRateType: ProposalStep3SingleDto) {
      const objIndex = this.step.findIndex(obj => obj.serviceRateType == stepRateType.serviceRateType)
      this.step[objIndex] = stepRateType
   }

   update = async () => {
      await this.sp.proposalsEditStore.autoSave.updateProposal(this.proposal)
   }

   stepHasService = (rateType: any) => {
      const step = this.step.find(step => step.serviceRateType === rateType)
      return !!(step && step.services.length)
   }

   getStepByRateType = (rateType: ServiceRateTypeEnum) => {
      const rateTypeStep = this.step.find(({ serviceRateType }) => serviceRateType === rateType)
      if (rateTypeStep) {
         switch (rateType) {
            case 'Per annum':
               return rateTypeStep as ProposalStep3ServiceAnnualDto
            case 'One-time fee':
               return rateTypeStep as ProposalStep3ServiceOneTimeDto
            case 'Per month':
               return rateTypeStep as ProposalStep3ServiceMonthlyDto
            case 'Per session':
               return rateTypeStep as ProposalStep3ServiceSessionDto
            case 'Per unit':
               return rateTypeStep as ProposalStep3ServiceUnitDto
         }
      }
      return undefined
   }
}

export const { Provider: ProposalsEditPaymentStoreProvider, useProvidedStore: useProposalsEditPaymentStore } = createStoreContext(ProposalsEditPaymentStore)
